import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { Xoa } from "./Xoa";

export const BtnXoa = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Xoá"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
         <img src="/app-assets/images/icon-xoa-v2.png" style={{marginBottom:"3px"}} />
        </PopoversBootrap>
      </a>
      {show && (
        <Xoa show={show} onHide={handleClose} chovayId={item.ChoVayId} />
      )}
    </>
  );
};
